import {connect} from "react-redux";

import ChatCase from "../../../components/Chat/ChatCase/ChatCase";
import {getCaseById, getContactById,} from "../../../selectors/case";
import {postMessage, setMessageValue} from "../../../actions/chatCase/form";
import {getMessages, setIdCase, updateUnreadMessages} from "../../../actions/chatCase/messages";
import {getDocuments, toggleSideBar} from "../../../actions/chatCase/document";
import {
setShowAcceptDevisModal,
setShowAcceptPapModal,
setShowModalNoRerender,
setShowModalRerender,
setShowRejectDevisModal,
setShowRejectPapModal,
setSuccessUploadMess
} from "../../../actions/modal";
import {acceptPap, rejectPap, setShowPap} from "../../../actions/chatCase/pap";
import {changeStatus, getCases} from "../../../actions/cases";
import {updateDevisState} from "../../../actions/chatCase/devis";

const MapStateToProps = (state, ownProps) => {

const cas = getCaseById(state.cases.listCasesWithManager, ownProps.id);

const contact = getContactById(state.cases.listContacts, ownProps.id);

// const documents = state.cases.listDocuments.map((doc) => doc);

return {
cas,
contact,
test: cas,
loadingCases: state.cases.loadingCases,
messages: state.chatCase.messages,
listContacts: state.cases.listContacts,
messageValue: state.chatCase.messageValue,
idCase: state.chatCase.idCase,
documents: state.chatCase.documents,
showModal: state.modal.showModal,
showModalNoRerender: state.modal.showModalNoRerender,
showAcceptPapModal: state.modal.showAcceptPapModal,
showRejectPapModal: state.modal.showRejectPapModal,
showRejectDevisModal: state.modal.showRejectDevisModal,
showAcceptDevisModal: state.modal.showAcceptDevisModal,
successUploadMess: state.modal.successUploadMess,
errorUploadMess: state.modal.errorUploadMess,
showPap: state.chatCase.showPap,
showSideBar: state.chatCase.showSideBar
};
};

const MapDispatchToProps = (dispatch) => ({
setMessageValue: (value, idCase) => {
dispatch(setMessageValue(value, idCase));
},
postMessage: () => {
dispatch(postMessage());
},
getMessages: () => {
dispatch(getMessages());
},
getDocuments: () => {
dispatch(getDocuments());
},
setShowModalRerender: (bool) => {
dispatch(setShowModalRerender(bool));
},
setShowModalNoRerender: (bool) => {
dispatch(setShowModalNoRerender(bool));
},
setShowPap: (bool) => {
dispatch(setShowPap(bool));
},
setShowAcceptDevisModal: (bool, id) => {
dispatch(setShowAcceptDevisModal(bool, id));
},
setShowRejectDevisModal: (bool, id) => {
dispatch(setShowRejectDevisModal(bool, id));
},
setShowAcceptPapModal: (bool) => {
dispatch(setShowAcceptPapModal(bool));
},
setShowRejectPapModal: (bool, id) => {
dispatch(setShowRejectPapModal(bool, id));
},
setIdCase: (idCase) => {
dispatch(setIdCase(idCase));
},
setSuccessUploadMess: (msg) => {
dispatch(setSuccessUploadMess(msg));
},
acceptPap: () => {
dispatch(acceptPap());
},
rejectPap: () => {
dispatch(rejectPap());
},
getCases: () => {
dispatch(getCases());
},
changeStatus: (status, idCase) => {
dispatch(changeStatus(status, idCase));
},
updateUnreadMessages: (idCase) => {
dispatch(updateUnreadMessages(idCase));
},
updateDevisState: (state) => {
dispatch(updateDevisState(state));
},
toggleSideBar: (bool) => {
dispatch(toggleSideBar(bool));
},
});

export default connect(MapStateToProps, MapDispatchToProps)(ChatCase);